<template>
  <b-form-group>
    <span v-if="isHide()">无权限查看此项配置</span>
    <template v-else>
      <span v-if="!notData">
        <b-form-select
          v-if="conf.__options__"
          v-model="conf.__value__"
          :options="conf.__options__"
          :disabled="isDisabled()"
          :required="conf.__required__"
        />
        <el-date-picker
          v-else-if="conf.__type__ === 'DATETIME'"
          :readonly="isDisabled()"
          v-model="conf.__value__"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          :placeholder="conf.__desc__"
          :required="conf.__required__"
        />
        <b-form-input
          v-else
          :type="type"
          :placeholder="''+conf.__default__"
          v-model="conf.__value__"
          :disabled="isDisabled()"
          :required="conf.__required__"
        />
        <b-form-text>{{ conf.__desc__ }}</b-form-text>
      </span>
    </template>
  </b-form-group>
</template>

<script>
import consts from '@/utils/consts'
import utils from '@/utils/utils'

export default {
  name: 'conf-field',
  props: ['conf', 'useDefault', 'userPerm', 'strict', 'previewing', 'notData'],
  data: () => {
    return {
      oldValue: this.value
    }
  },
  created () {
    if (this.conf.__type__ === 'DATETIME') {
      this.$set(this.conf, '__value__', this.conf.__default__ || utils.formatDate(new Date()))
    } else if (this.useDefault && utils.isUndefined(this.conf.__value__)) {
      this.$set(this.conf, '__value__', this.conf.__default__)
    }
  },
  computed: {
    type: function () {
      if (utils.isUndefined(this.conf.__type__)) {
        console.log(this.conf)
      }
      if (this.conf.__type__.indexOf('INT') !== -1) {
        return 'number'
      } else {
        return 'text'
      }
    }
  },
  methods: {
    isDisabled () {
      if (!this.conf.__public__ || !this.strict) {
        return false
      } else if (this.previewing) {
        return true
      } else if (this.conf.__public__ === 'WRITE') {
        if (!this.userPerm) {
          return true
        }
        if (parseInt(this.conf.__perm__[consts.PERM_BIT.superAdmin]) && this.$store.getters.loginInfo.admin_type !== 'super') {
          return true
        }
        if (this.conf.__perm__) {
          if (parseInt(this.conf.__perm__[consts.PERM_BIT.confWrite]) > parseInt(this.userPerm[consts.PERM_BIT.confWrite])) {
            return true
          }
        }
        return false
      }
      return true
    },
    isHide () {
      if (!this.conf.__public__ || !this.strict) {
        return false
      }
      if (!this.userPerm) {
        return true
      }
      if (parseInt(this.conf.__perm__[consts.PERM_BIT.superAdmin]) && this.$store.getters.loginInfo.admin_type !== 'super') {
        return true
      }
      if (this.conf.__perm__) {
        if (parseInt(this.conf.__perm__[consts.PERM_BIT.confRead]) > parseInt(this.userPerm[consts.PERM_BIT.confRead])) {
          return true
        }
      }
      return false
    },
    checkValue (value) {
      let passed = true
      if (this.conf.__range__ && (
        parseInt(value) < this.conf.__range__[0] || parseInt(value) > this.conf.__range__[1]
      )) {
        passed = false
      }
      if (this.conf.__options__ && this.conf.__options__.indexOf(value) === -1) {
        passed = false
      }
      if (this.conf.__re__) {
        let re = new RegExp(this.conf.__re__)
        if (!re.test(value)) {
          passed = false
        }
      }
      if (!passed) {
        this.conf.__value__ = this.oldValue
        this.$message.error('参数不符合要求')
      } else {
        this.oldValue = value
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Conffield.vue?4ee7595e